import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: (props: { error: Error; reset: () => void }) => ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    const { error } = this.state;
    if (error) {
      if (this.props.fallback) {
        return this.props.fallback({ error, reset: this.reset });
      }
      return (
        <div style={{ padding: '2rem', maxWidth: '480px', margin: '4rem auto', textAlign: 'center' }}>
          <p style={{ color: 'var(--color-text-muted, #666)', marginBottom: '1rem', fontSize: '0.875rem' }}>
            Something went wrong on this page.
          </p>
          <button
            onClick={this.reset}
            style={{ padding: '0.5rem 1.25rem', borderRadius: '6px', cursor: 'pointer' }}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
